import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import { makeStyles, } from '@material-ui/core';
import { GenericStatusIndicator, } from '../..';
const useStyle = makeStyles((theme) => {
    return {
        root: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end',
            justifyContent: 'center',
        },
        deviceName: {
            color: theme.palette.text.secondary,
            textTransform: 'uppercase',
            fontSize: 12,
            fontWeight: 500,
            whiteSpace: 'nowrap',
            marginBottom: theme.spacing(0.2),
            [theme.breakpoints.up('md')]: {
                fontSize: 14,
            },
        },
        statusLabel: {
            fontSize: 18,
            [theme.breakpoints.up('md')]: {
                fontSize: 20,
            },
        },
    };
}, {
    name: 'DeviceStatus',
});
export const DeviceStatusIndicator = (props) => {
    const classes = useStyle();
    return (_jsxs("div", { className: clsx(classes.root, props.className), children: [_jsx("div", { className: clsx(classes.deviceName), children: props.deviceName }), _jsx(GenericStatusIndicator, { className: clsx(classes.statusLabel), label: props.statusLabel, status: Boolean(props.statusValue) })] }));
};
